import { render, staticRenderFns } from "./WarnTips.vue?vue&type=template&id=851a79dc"
import script from "./WarnTips.vue?vue&type=script&lang=ts"
export * from "./WarnTips.vue?vue&type=script&lang=ts"
import style0 from "./WarnTips.vue?vue&type=style&index=0&id=851a79dc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports